import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@app/store/types';
import { getUserEmail } from '@app/store/user/selectors';

import { selectHostsById } from './reducers/host';

export const getSigningProgressInformation = (state: RootState) => state.signingProgressInformation;
export const getSigningProgressSignerAttachments = (state: RootState) =>
  getSigningProgressInformation(state).attachments;
export const getIsFetching = (state: RootState) => getSigningProgressInformation(state).isFetching;
export const getDocument = (state: RootState) => getSigningProgressInformation(state).document;
export const getHistories = (state: RootState) => getSigningProgressInformation(state).histories;
export const getParticipants = (state: RootState) =>
  getSigningProgressInformation(state).participants;
export const getHostsByDataLabel = (state: RootState) =>
  selectHostsById(getSigningProgressInformation(state).host);

export const getIsDocumentRequester = createSelector(
  getDocument,
  getUserEmail,
  (document, userEmail) => document.requester?.email === userEmail
);
